import {
  styled,
  Toolbar,
  Box,
  Tooltip,
  IconButton,
  Typography,
} from "@mui/material";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import { AiOutlineMenu } from "react-icons/ai";
import { useUiStore } from "hooks/useUiStore";
import { IconContext } from "react-icons";
import { MdAttachEmail } from "react-icons/md";
import { SettingsUser } from "./actions";
import { DarkMode } from "./components/darkMode";
import { FiHelpCircle } from "react-icons/fi";
import { Link } from "react-router-dom";

const drawerWidth = 270;

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

export const Navbar = () => {
  const { openDrawer, handleOpenDrawer } = useUiStore();

  return (
    <AppBar
      position="fixed"
      open={openDrawer}
      sx={{
        width: {
          xl: openDrawer ? `calc(100% - ${drawerWidth}px)` : "none",
          lg: openDrawer ? `calc(100% - ${drawerWidth}px)` : "none",
        },
        ml: { sm: `${drawerWidth}px` },
        paddingY: "0",
        boxShadow: "rgb(160 160 160 / 2%) 0px 5px 20px",
      }}
    >
      <div className="flex justify-between items-center mx-10">
        <Toolbar disableGutters>
          {!openDrawer ? (
            <IconButton
              onClick={() => handleOpenDrawer(true)}
              edge="start"
              sx={{ mr: 2, display: { sm: "" } }}
            >
              <IconContext.Provider
                value={{
                  className: "text-2xl text-slate-100 ease-nav-brand",
                }}
              >
                <AiOutlineMenu />
                <Typography
                  variant="h6"
                  className=" text-slate-100 ease-nav-brand menuComponent2"
                  sx={{
                    mr: 2,
                    display: { xs: "none", md: "flex", lg: "flex", xl: "flex" },
                    flexGrow: 1,
                    fontWeight: 400,
                    fontSize: 15,
                    letterSpacing: ".2rem",
                    marginLeft: 1,
                    textDecoration: "none",
                    justifyContent: "center",
                  }}
                >
                  Menú
                </Typography>
              </IconContext.Provider>
            </IconButton>
          ) : null}
        </Toolbar>
        <Typography
          variant="h6"
          className=" text-slate-100 ease-nav-brand"
          sx={{
            mr: 2,
            display: { xs: "none", md: "flex", lg: "flex", xl: "flex" },
            flexGrow: 1,
            fontWeight: 700,
            letterSpacing: ".3rem",
            textDecoration: "none",
            justifyContent: "center",
          }}
        >
          Tribunal Electrónico
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", width: 100 }}>
          <div className="cambioColor mt-1">
          <DarkMode />
          </div>
          <Tooltip title="Ayuda">
            <Link to="/dashboard/preguntas-frecuentes" className="mt-1 ayudaFAQ">
              <IconButton>
                <FiHelpCircle style={{ color: 'white' }} />
              </IconButton>
            </Link>
          </Tooltip>

          <IconButton>
            <a
              href={"https://mail.pjedomex.gob.mx/"}
              target="_blank"
              rel="noreferrer"
            >
              <IconContext.Provider
                value={{ className: "text-2xl text-slate-100 correo" }}
              >
                <MdAttachEmail />
              </IconContext.Provider>
            </a>
          </IconButton>
          {/* <IconButton>
            <Badge badgeContent={4} color="primary">
              <IconContext.Provider
                value={{ className: "text-2xl text-slate-100" }}
              >
                <MdNotificationsActive />
              </IconContext.Provider>
            </Badge>
          </IconButton>
          <IconButton>
            <Badge badgeContent={4} color="primary">
              <IconContext.Provider
                value={{ className: "text-2xl text-slate-100" }}
              >
                <BsFillChatDotsFill />
              </IconContext.Provider>
            </Badge>
          </IconButton> */}
          <div className="ajustes">
          <Tooltip title="Ajustes">
            <IconButton>
              <SettingsUser />
            </IconButton>
          </Tooltip>
          </div>

        </Box>
      </div>
    </AppBar>
  );
};
